<template>
  <button class="btn btn-primary btn-lg" :disabled="disabled" @click="submit">
    {{ lang.get('buttons.save') }}
  </button>
</template>

<script>
import { mapActions, mapState, mapGetters } from 'vuex';
export default {
  inject: ['lang'],
  computed: {
    disabled() {
      return (
        this.configurationMode ||
        this.uploadInProgress ||
        !this.isSaveable ||
        !this.isLoaded ||
        this.ajaxInProgress
      );
    },
    ...mapState('entryForm', ['uploadInProgress']),
    ...mapGetters('entryForm', ['isSaveable', 'isLoaded']),
    ...mapState('entryFormApi', ['ajaxInProgress']),
    ...mapState('entryFormConfiguration', ['configurationMode'])
  },
  methods: {
    ...mapActions('entryFormApi', { submit: 'save' })
  }
};
</script>
